import React from 'react'
import { Route } from 'react-router-dom'
import RoutesWrapper from '../RoutesWrapper'

const Stage5 = React.lazy(
  () => import('../../pages/stages/stage5/Stage5Main'),
)
const Stage5Story = React.lazy(
  () => import('../../pages/stages/stage5/Stage5Story'),
)
const Stage5Ending = React.lazy(
  () => import('../../pages/stages/stage5/Stage5Ending'),
)

const loc = `stage5`

export const Stage5Routes = (
  <>
    <Route
      path="/stage5"
      element={
        <RoutesWrapper loc={loc}>
          <Stage5 />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage5/story"
      element={
        <RoutesWrapper loc={loc}>
          <Stage5Story />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage5/ending"
      element={
        <RoutesWrapper loc={loc}>
          <Stage5Ending />
        </RoutesWrapper>
      }
    />
  </>
)
